import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  AppListLayout,
  BtnInfo,
  IntelligentTableView,
} from "../common/application/query/dto";
import { useParams } from "react-router-dom";
import { Button, Divider, NavBar, Popup, Space, Tabs } from "antd-mobile-v5";
import DataList from "../component/DataList";
import { IntelligentTableService } from "../common/application/query/service/IntelligentTableService";
import { Description } from "../component/schema";
import { TableGrid } from "../component/Tablegrid";
import { CloseOutline } from "antd-mobile-icons";
import instance from "../util/axios";
import { DescriptionService } from "../common/application/query/service/DescriptionService";

export function FastGrid() {
  const [sessionInfo, setSessionInfo] = useState<{
    userId: string;
    name: string;
  }>({ userId: "", name: "" });

  useEffect(() => {
    instance.get(`/crm/user/`).then((resp) => {
      setSessionInfo(resp.data.Data);
    });
  }, []);

  const params = useParams<{ uuid: string }>();
  const [views, setViews] = useState<IntelligentTableView[]>([]);
  const [descriptions, setDescriptions] = useState<Description[]>([]);
  const [innerBtnList, setInnerBtnList] = useState<BtnInfo[]>([]);
  useEffect(() => {
    IntelligentTableService.getTableAndView(params.uuid).then((resp) => {
      setViews(resp.data.Data);
      if (resp.data.Data.length) {
        handleTabChange(resp.data.Data[0].uuid);
      }
    });

    IntelligentTableService.getTable(params.uuid).then((resp) => {
      if (resp.data.Status === "1") {
        const data = resp.data.Data;
        setTable({
          tableName: data.name,
        });
      }
    });
  }, []);

  const [activeTabKey, setActiveTabKey] = useState<string>();
  const [appListLayout, setAppListLayout] = useState<AppListLayout>();
  const [table, setTable] = useState<{ tableName: string }>();
  const [detailForm, setDetailForm] = useState<{
    visible: boolean;
    uuid?: string;
  }>({
    visible: false,
  });
  const [tableGridForm, setTableGridForm] = useState<{
    visible: boolean;
    tableName?: string;
    defaultValues?: { [p: string]: any };
  }>({
    visible: false,
  });
  const [listForm, setListForm] = useState<{
    visible: boolean;
    tableName?: string;
    defaultValues?: { [p: string]: any };
    descriptions?: Description[];
  }>({
    visible: false,
  });
  const handleTabChange = useCallback((key: string) => {
    setActiveTabKey(key);
    IntelligentTableService.getNewFieldDescriptionList(key).then((resp) => {
      setDescriptions(resp.data.Data);

      IntelligentTableService.getAppListLayoutByViewId(key).then((response) => {
        setAppListLayout(response.data.Data);

        setUrl(
          `/crm/intelligentTableView/getDataListByViewId?tableName=${key}&filterId=&filter=`
        );
      });

      IntelligentTableService.getViewButton(key).then((resp) => {
        if (resp.data.Status === "1") {
          setInnerBtnList(
            resp.data.Data.filter((item) => item.position === "1")
          );
        }
      });
    });
  }, []);

  const tableGridRef = useRef<any>();

  const [url, setUrl] = useState<string>();
  return sessionInfo.name ? (
    <>
      <Tabs
        className={
          "[&_.adm-tabs-content]:p-0 [&_.am-list-body]:bg-transparent [&_.adm-tabs-header]:bg-white"
        }
        onChange={handleTabChange}
        activeKey={views.length ? views[0].uuid : undefined}
      >
        {views.map((view) => {
          return (
            <Tabs.Tab title={view.showName} key={activeTabKey}>
              {url && appListLayout ? (
                <DataList
                  render={(item: any, index) => {
                    return (
                      <div className={`bg-white ${index > 0 ? "mt-2" : ""}`}>
                        <div className={`p-4`}>
                          <Space direction={"vertical"} className={"w-full"}>
                            <div
                              style={{
                                display: "flex",
                                gap: "10px",
                                justifyContent: "space-between",
                              }}
                            >
                              <span
                                style={{
                                  flex: "1",
                                }}
                              >
                                {appListLayout.topLeftFieldInfo.fieldShowName}
                                :&nbsp;
                                {item[appListLayout.topLeftFieldInfo.fieldName]}
                              </span>
                              <span>
                                {item[
                                  appListLayout?.topRightFieldInfo.fieldName
                                ].substring(0, 10)}
                              </span>
                            </div>
                            <span>
                              {appListLayout?.titleFieldInfo.fieldShowName}
                              :&nbsp;
                              {item[appListLayout.titleFieldInfo.fieldName]}
                            </span>
                            <table>
                              <tr>
                                <td className={"w-2/3"}>
                                  <Space direction={"vertical"}>
                                    {appListLayout?.contentFieldInfo.map(
                                      (contentFieldInfo) => {
                                        return (
                                          <div>
                                            {contentFieldInfo.fieldShowName}
                                            :&nbsp;
                                            {item[contentFieldInfo.fieldName]}
                                          </div>
                                        );
                                      }
                                    )}
                                  </Space>
                                </td>
                                <td className={"w-1/3 text-right"}>
                                  {
                                    item[
                                      appListLayout.bottomRightFieldInfo
                                        .fieldName
                                    ]
                                  }
                                </td>
                              </tr>
                            </table>
                          </Space>
                        </div>
                        <Divider direction={"horizontal"} className={"m-0"} />
                        <div className={"p-2"}>
                          <Space
                            wrap={true}
                            className={"text-right w-full justify-end"}
                          >
                            {innerBtnList
                              .filter((button) => {
                                if (
                                  button.filters &&
                                  typeof button.filters === "string" &&
                                  JSON.parse(button.filters).length > 0
                                ) {
                                  const filters = JSON.parse(button.filters);
                                  let flag = true;
                                  for (let i = 0; i < filters.length; i++) {
                                    let filter = filters[i];
                                    if (filter.compareType === "in") {
                                      if (filter.value === "本人") {
                                        if (
                                          sessionInfo.name !==
                                          item[filter.fieldName]
                                        ) {
                                          flag = false;
                                        }
                                      } else {
                                        if (
                                          filter.value !==
                                          item[filter.fieldName]
                                        ) {
                                          flag = false;
                                        }
                                      }
                                    }
                                  }
                                  return flag;
                                }
                                return true;
                              })
                              .map((button) => {
                                const conversionInfo: {
                                  data: [
                                    {
                                      prevField: string;
                                      nextField: string;
                                    }
                                  ];
                                } = JSON.parse(button.conversionInfo || "");
                                const defaultValues: { [p: string]: any } = {};
                                for (let datum of conversionInfo.data) {
                                  if (!datum.prevField || !datum.nextField) {
                                    continue;
                                  }
                                  defaultValues[datum.nextField] =
                                    item.ref[datum.prevField];
                                }
                                if (button.tableName) {
                                  if (
                                    button.type === "list" ||
                                    button.type === "simple-list"
                                  ) {
                                    return (
                                      <Button
                                        className={"rounded-full text-xs"}
                                        onClick={async () => {
                                          const resp =
                                            await DescriptionService.get(
                                              button.tableName!
                                            );
                                          setListForm({
                                            visible: true,
                                            tableName: button.tableName,
                                            defaultValues: defaultValues,
                                            descriptions:
                                              button.type === "simple-list"
                                                ? resp.data.Data.slice(0, 6)
                                                : resp.data.Data,
                                          });
                                        }}
                                      >
                                        {button.name}
                                      </Button>
                                    );
                                  }
                                  return (
                                    <Button
                                      className={"rounded-full text-xs"}
                                      onClick={() => {
                                        setTableGridForm({
                                          visible: true,
                                          tableName: button.tableName,
                                          defaultValues,
                                        });
                                      }}
                                    >
                                      {button.name}
                                    </Button>
                                  );
                                } else {
                                  return (
                                    <Button
                                      className={"rounded-full text-xs"}
                                      onClick={() => {
                                        setDetailForm({
                                          visible: true,
                                          uuid: item.uuid,
                                        });
                                      }}
                                    >
                                      {button.name}
                                    </Button>
                                  );
                                }
                              })}
                          </Space>
                        </div>
                      </div>
                    );
                  }}
                  descriptions={descriptions}
                  url={url}
                />
              ) : (
                <></>
              )}
            </Tabs.Tab>
          );
        })}
      </Tabs>
      <Popup
        visible={detailForm.visible}
        onMaskClick={() => {
          setDetailForm({
            visible: false,
          });
        }}
        position="right"
      >
        <NavBar
          onBack={() => {
            setDetailForm({
              visible: false,
            });
          }}
          backArrow={<CloseOutline />}
        >
          详情
        </NavBar>
        {detailForm.visible ? (
          <TableGrid
            className={"overflow-auto h-[calc(100vh-64px)]"}
            id={detailForm.uuid}
            entityName={table!.tableName}
          />
        ) : (
          <></>
        )}
      </Popup>
      <Popup
        visible={tableGridForm.visible}
        onMaskClick={() => {
          setTableGridForm({
            visible: false,
          });
        }}
        position="right"
      >
        <NavBar
          right={
            <Button
              fill={"none"}
              color={"primary"}
              onClick={async () => {
                await tableGridRef.current?.save();
              }}
            >
              保存
            </Button>
          }
          onBack={() => {
            setTableGridForm({
              visible: false,
            });
          }}
          backArrow={<CloseOutline />}
        >
          新建联系记录
        </NavBar>
        {tableGridForm.visible ? (
          <TableGrid
            onSaved={() =>
              setTableGridForm({
                visible: false,
              })
            }
            ref={tableGridRef}
            entityName={tableGridForm.tableName!}
            defaultValues={tableGridForm.defaultValues}
          />
        ) : (
          <></>
        )}
      </Popup>
      <Popup
        visible={listForm.visible}
        onMaskClick={() => {
          setListForm({
            visible: false,
          });
        }}
        bodyStyle={{ width: "80vw" }}
        position="right"
        className={"[&_.am-list]:h-full [&_.am-list]:overflow-auto"}
      >
        <NavBar
          onBack={() => {
            setListForm({
              visible: false,
            });
          }}
          backArrow={<CloseOutline />}
        >
          查看
        </NavBar>
        {listForm.visible ? (
          <DataList
            sorter={{
              field: "createTime",
              order: "descend",
            }}
            descriptions={listForm.descriptions!}
            url={`/crm/intelligentTableView/getList?tableName=${
              listForm.tableName
            }&defaultFilter=${encodeURI(
              ` and (${Object.keys(listForm.defaultValues!)
                .map(
                  (key, index) =>
                    `${index > 0 ? " and " : " "}${key}='${
                      listForm.defaultValues![key]
                    }'`
                )
                .join(" ")})`
            )}`}
          />
        ) : (
          <></>
        )}
      </Popup>
    </>
  ) : (
    <></>
  );
}
